var React = require('react');

function CloseWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path","d":"M16,1.712,14.389,0,8,6.788,1.611,0,0,1.712,6.389,8.5,0,15.288,1.611,17,8,10.212,14.389,17,16,15.288,9.611,8.5Z","fill":"#fff"}));
}

CloseWhite.defaultProps = {"className":"svg-icon","viewBox":"0 0 16 17"};

module.exports = CloseWhite;

CloseWhite.default = CloseWhite;
